import { type FC } from 'react';

import type { ApplicationCta } from '@core/blocks/best-match-experience/types';
import useDualCtaTest from '@core/hooks/useDualCtaTest';
import useProgramCode from '@core/hooks/useProgramCode';
import type { VoyagerResult } from '@core/ts/results';

import ApplicationCTA from '../../ApplicationCTA';
import SchoolInfoHeader from '../../SchoolInfoHeader';
import ExitStrategyCongratsBanner from '../ExitStrategyCongratsBanner';
import ExitStrategyContent from '../ExitStrategyContent';
import styles from './ExitStrategyPopup.module.css';

type Props = {
  firstName: string;
  result: VoyagerResult;
  currentResultApplicationCta: ApplicationCta;
  isCurrentResultApplicationCtaLoading?: boolean;
};

const ExitStrategyPopup: FC<Props> = ({
  firstName,
  result,
  currentResultApplicationCta,
  isCurrentResultApplicationCtaLoading,
}) => {
  // fetch program code once program id is available
  const programCode = useProgramCode(result?.program?.id);

  const schoolId = result?.school?.id?.toString() || '';
  const { DualCtaTestComponent, shouldApplyWrapperStyles } = useDualCtaTest(schoolId, programCode);

  return (
    <section className={styles.exitStrategyContainer}>
      <SchoolInfoHeader result={result} />
      <div className={styles.popupContentContainer}>
        <ExitStrategyCongratsBanner firstName={firstName} />
        {currentResultApplicationCta && currentResultApplicationCta?.url && (
          <div className={styles.applicationCtaPopupCard}>
            {/* Wrap both CTAs so layout flips cleanly when Dual CTA is active */}
            <div className={shouldApplyWrapperStyles ? styles.dualCta : styles.singleCta}>
              <ApplicationCTA
                result={result}
                cta={currentResultApplicationCta}
                isLoading={isCurrentResultApplicationCtaLoading}
              />
              {/* Dual CTA (hook controls visibility) */}
              <DualCtaTestComponent schoolId={schoolId} />
            </div>
          </div>
        )}
        <ExitStrategyContent result={result} />
      </div>
    </section>
  );
};

export default ExitStrategyPopup;
